<script>
  export let selectedItem;
  export let deliveries;
  export let transportes;
  export let vehiculos;
  export let escoltas;
  export let dispatch;
  export let closePane;

  let deliveryMethod = selectedItem.delivery_method || '';
  let selectedDelivery = selectedItem.delivery || '';
  let selectedTransporte = selectedItem.transporte || '';
  let selectedVehiculo = selectedItem.vehiculo || '';
  let transporteRef = selectedItem.transporte_ref || '';
  let targetRef = selectedItem.target_ref || '';
  let editMode = false;
  
  // Selected escoltas array
  let selectedEscoltas = [];
  
  // Load existing escoltas if any
  function loadExistingEscoltas() {
    console.log("Loading existing escoltas from:", selectedItem.escoltas);
    
    if (selectedItem && selectedItem.escoltas) {
      // Ensure it's an array
      if (Array.isArray(selectedItem.escoltas)) {
        // Extract just the escolta IDs from the objects
        selectedEscoltas = selectedItem.escoltas.map(escoltaItem => {
          // If it's the expanded structure from the JSON
          if (escoltaItem.escolta) {
            return escoltaItem.escolta;
          }
          // If it's already just the ID
          else if (typeof escoltaItem === 'string') {
            return escoltaItem;
          }
          // If it has an id property (fallback)
          else if (escoltaItem.id) {
            return escoltaItem.id;
          }
          return null;
        }).filter(Boolean); // Remove any null values
      } else {
        // Handle case where escoltas might be an object or string
        try {
          // Try to parse it if it's a string representation of array
          const parsed = typeof selectedItem.escoltas === 'string' 
            ? JSON.parse(selectedItem.escoltas) 
            : selectedItem.escoltas;
          
          if (Array.isArray(parsed)) {
            // Extract IDs using the same mapping logic
            selectedEscoltas = parsed.map(escoltaItem => {
              if (escoltaItem.escolta) {
                return escoltaItem.escolta;
              } else if (typeof escoltaItem === 'string') {
                return escoltaItem;
              } else if (escoltaItem.id) {
                return escoltaItem.id;
              }
              return null;
            }).filter(Boolean);
          } else {
            selectedEscoltas = [];
          }
        } catch (e) {
          console.error("Error parsing escoltas:", e);
          selectedEscoltas = [];
        }
      }
      
      console.log("Existing escoltas loaded:", selectedEscoltas);
    } else {
      selectedEscoltas = [];
    }
  }
  // Call on component initialization
  loadExistingEscoltas();

  function saveDelivery() {
    const payload = {
      id: selectedItem.id,
      delivery_method: deliveryMethod,
      delivery: selectedDelivery,
      transporte: selectedTransporte,
      vehiculo: selectedVehiculo,
      target_ref: targetRef,
      transporte_ref: transporteRef
    };

    console.log("Dispatching updateDelivery:", payload);
    dispatch('updateDelivery', payload);
    
    // Save escoltas to egresoEscolta collection if delivery method is Repartidor
    if (selectedEscoltas.length > 0) {
      console.log("Saving escoltas:", selectedEscoltas);
      dispatch('updateEgresoEscolta', {
        egresoId: selectedItem.id,
        escoltas: selectedEscoltas
      });
    }

    editMode = false;
    closePane();
  }

  function toggleEditMode() {
    editMode = !editMode;
    if (editMode) {
      loadExistingEscoltas();
    }
  }
  
  function toggleEscolta(escoltaId) {
    const index = selectedEscoltas.indexOf(escoltaId);
    if (index === -1) {
      selectedEscoltas = [...selectedEscoltas, escoltaId];
    } else {
      selectedEscoltas = selectedEscoltas.filter(id => id !== escoltaId);
    }
  }
  
  function isEscoltaSelected(escoltaId) {
    return selectedEscoltas.includes(escoltaId);
  }
  
  // Get escolta names for display
  function getEscoltaNames() {
    if (!selectedEscoltas || selectedEscoltas.length === 0) return 'Ninguno seleccionado';
    
    // If we're in edit mode, we're working with IDs and need to look them up in the escoltas array
    if (editMode) {
      if (!escoltas || !Array.isArray(escoltas) || escoltas.length === 0) {
        return 'Datos de escoltas no disponibles';
      }
      
      const names = selectedEscoltas
        .map(id => {
          const escolta = escoltas.find(e => e.id === id);
          return escolta ? escolta.nombre : null;
        })
        .filter(Boolean)
        .join(', ');
        
      return names || 'Ninguno seleccionado';
    } 
    // In view mode, we're working with the expanded escoltas from selectedItem
    else {
      if (!selectedItem.escoltas || !Array.isArray(selectedItem.escoltas) || selectedItem.escoltas.length === 0) {
        return 'Ninguno seleccionado';
      }
      
      const names = selectedItem.escoltas
        .map(e => {
          // Access the expanded escolta data correctly
          if (e.expand && e.expand.escolta && e.expand.escolta.nombre) {
            return e.expand.escolta.nombre;
          }
          // Fallback if expand structure isn't available
          return null;
        })
        .filter(Boolean)
        .join(', ');
        
      return names || 'Ninguno seleccionado';
    }
  }
</script>

<div class="space-y-4">
  <div>
    <h2 class="text-lg font-bold text-blueGray-700 mb-4">Definir Entrega</h2>

    <!-- Current Delivery Info (if exists) -->
    <div class="mb-4 p-4 border rounded bg-blueGray-50">
      <h3 class="font-medium text-blueGray-700 mb-2">Método de entrega actual:</h3>
      
      <!-- Display as labels if not in edit mode -->
      {#if !editMode}
        <p><strong>Método:</strong> {selectedItem.delivery_method || 'No definido'}</p>
        
          <p><strong>Repartidor:</strong> {deliveries.find(d => d.id === selectedItem.delivery)?.nombre || 'No seleccionado'}</p>
          <p><strong>Vehículo:</strong> {selectedItem.vehiculo ? 
            `${vehiculos.find(v => v.id === selectedItem.vehiculo)?.placa} / ${vehiculos.find(v => v.id === selectedItem.vehiculo)?.marca} ${vehiculos.find(v => v.id === selectedItem.vehiculo)?.modelo} (${vehiculos.find(v => v.id === selectedItem.vehiculo)?.color})` 
            : 'No seleccionado'}</p>
          <p><strong>Escoltas:</strong> {getEscoltaNames()}</p>
          <p><strong>Referencia:</strong> {selectedItem.target_ref || 'Sin referencia'}</p>
        
          <p><strong>Transporte:</strong> {transportes.find(c => c.id === selectedItem.transporte)?.descrip || 'No seleccionado'}</p>
          <p><strong>Referencia:</strong> {selectedItem.transporte_ref || 'Sin referencia'}</p>
        

        <!-- Edit Button -->
        <button
          class="mt-2 bg-blueGray-600 text-white active:bg-blueGray-700 font-bold uppercase text-sm px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
          on:click={toggleEditMode}
        >
          Editar
        </button>
      {:else}
        <!-- Edit Mode: Show Input Fields -->
        <form on:submit|preventDefault={saveDelivery}>
          <div class="mb-4">
            <label class="block text-blueGray-700 text-sm font-bold mb-2" for="deliveryMethod">
              Método de Entrega
            </label>
            <select
              id="deliveryMethod"
              class="shadow appearance-none border rounded w-full py-2 px-3 text-blueGray-700 leading-tight focus:outline-none focus:shadow-outline"
              bind:value={deliveryMethod}
              required
            >
              <option value="">Seleccione un método</option>
              <option value="Despacho">Despacho</option>
              <option value="Repartidor">Repartidor</option>
              <option value="Transporte">Transporte</option>
            </select>
          </div>

          <!-- Conditional Fields -->
          {#if deliveryMethod === 'Repartidor'}
            <div class="mb-4">
              <label class="block text-blueGray-700 text-sm font-bold mb-2" for="selectedDelivery">
                Datos del Repartidor
              </label>
              <select
                id="selectedDelivery"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-blueGray-700 leading-tight focus:outline-none focus:shadow-outline"
                bind:value={selectedDelivery}
                required
              >
                <option value="">Seleccione repartidor</option>
                {#each deliveries as delivery}
                  <option value={delivery.id}>{delivery.nombre}</option>
                {/each}
              </select>
            </div>
            
            <!-- Vehicle Select -->
            <div class="mb-4">
              <label class="block text-blueGray-700 text-sm font-bold mb-2" for="selectedVehiculo">
                Vehículo
              </label>
              <select
                id="selectedVehiculo"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-blueGray-700 leading-tight focus:outline-none focus:shadow-outline"
                bind:value={selectedVehiculo}
                required
              >
                <option value="">Seleccione vehículo</option>
                {#each vehiculos as vehiculo}
                  <option value={vehiculo.id}>{vehiculo.placa} / {vehiculo.marca} {vehiculo.modelo} - {vehiculo.color}</option>
                {/each}
              </select>
            </div>
            
            <!-- Multiple Escoltas Selection -->
            <div class="mb-4">
              <label class="block text-blueGray-700 text-sm font-bold mb-2" for="">
                Escoltas
              </label>
              <div class="bg-white shadow overflow-hidden border rounded-md">
                {#if escoltas && escoltas.length > 0}
                  <ul class="divide-y divide-gray-200">
                    {#each escoltas as escolta}
                      <li class="relative">
                        <label class="flex items-center px-4 py-3 hover:bg-blueGray-50 cursor-pointer">
                          <input 
                            type="checkbox" 
                            class="mr-3 h-4 w-4 text-blue-600"
                            checked={isEscoltaSelected(escolta.id)}
                            on:change={() => toggleEscolta(escolta.id)} 
                          />
                          <span class="block text-sm text-blueGray-700">{escolta.nombre}</span>
                        </label>
                      </li>
                    {/each}
                  </ul>
                {:else}
                  <div class="p-4 text-sm text-blueGray-500 text-center">
                    No hay escoltas disponibles
                  </div>
                {/if}
              </div>
              <div class="mt-2 text-xs text-blueGray-500">
                {selectedEscoltas.length} escolta(s) seleccionado(s)
              </div>
            </div>
            
            <div class="mb-4">
              <label class="block text-blueGray-700 text-sm font-bold mb-2" for="targetRef">
                Referencia de entrega
              </label>
              <input
                id="targetRef"
                type="text"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-blueGray-700 leading-tight focus:outline-none focus:shadow-outline"
                bind:value={targetRef}
                placeholder="Ingrese la referencia de entrega"
                required
              />
            </div>
          {:else if deliveryMethod === 'Transporte'}
            <div class="mb-4">
              <label class="block text-blueGray-700 text-sm font-bold mb-2" for="selectedDelivery">
                Datos del Repartidor
              </label>
              <select
                id="selectedDelivery"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-blueGray-700 leading-tight focus:outline-none focus:shadow-outline"
                bind:value={selectedDelivery}
                required
              >
                <option value="">Seleccione repartidor</option>
                {#each deliveries as delivery}
                  <option value={delivery.id}>{delivery.nombre}</option>
                {/each}
              </select>
            </div>
            
            <!-- Vehicle Select -->
            <div class="mb-4">
              <label class="block text-blueGray-700 text-sm font-bold mb-2" for="selectedVehiculo">
                Vehículo
              </label>
              <select
                id="selectedVehiculo"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-blueGray-700 leading-tight focus:outline-none focus:shadow-outline"
                bind:value={selectedVehiculo}
                required
              >
                <option value="">Seleccione vehículo</option>
                {#each vehiculos as vehiculo}
                  <option value={vehiculo.id}>{vehiculo.placa} / {vehiculo.marca} {vehiculo.modelo} - {vehiculo.color}</option>
                {/each}
              </select>
            </div>
            
            <!-- Multiple Escoltas Selection -->
            <div class="mb-4">
              <label class="block text-blueGray-700 text-sm font-bold mb-2" for="">
                Escoltas
              </label>
              <div class="bg-white shadow overflow-hidden border rounded-md">
                {#if escoltas && escoltas.length > 0}
                  <ul class="divide-y divide-gray-200">
                    {#each escoltas as escolta}
                      <li class="relative">
                        <label class="flex items-center px-4 py-3 hover:bg-blueGray-50 cursor-pointer">
                          <input 
                            type="checkbox" 
                            class="mr-3 h-4 w-4 text-blue-600"
                            checked={isEscoltaSelected(escolta.id)}
                            on:change={() => toggleEscolta(escolta.id)} 
                          />
                          <span class="block text-sm text-blueGray-700">{escolta.nombre}</span>
                        </label>
                      </li>
                    {/each}
                  </ul>
                {:else}
                  <div class="p-4 text-sm text-blueGray-500 text-center">
                    No hay escoltas disponibles
                  </div>
                {/if}
              </div>
              <div class="mt-2 text-xs text-blueGray-500">
                {selectedEscoltas.length} escolta(s) seleccionado(s)
              </div>
            </div>
            <div class="mb-4">
              <label class="block text-blueGray-700 text-sm font-bold mb-2" for="selectedTransporte">
                Datos del Transporte
              </label>
              <select
                id="selectedTransporte"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-blueGray-700 leading-tight focus:outline-none focus:shadow-outline"
                bind:value={selectedTransporte}
                required
              >
                <option value="">Seleccione transporte</option>
                {#each transportes as transporte}
                  <option value={transporte.id}>{transporte.descrip}</option>
                {/each}
              </select>
            </div>
            
            <div class="mb-4">
              <label class="block text-blueGray-700 text-sm font-bold mb-2" for="transporteRef">
                Referencia de entrega
              </label>
              <input
                id="transporteRef"
                type="text"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-blueGray-700 leading-tight focus:outline-none focus:shadow-outline"
                bind:value={transporteRef}
                placeholder="Ingrese la referencia de transporte"
                required
              />
            </div>
          {/if}

          <!-- Save and Cancel Buttons -->
          <div class="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
            <button
              class="bg-blueGray-600 text-white active:bg-blueGray-700 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
              type="button"
              on:click={toggleEditMode}
            >
              Cancelar
            </button>
            <button
              class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
              type="submit"
            >
              Guardar Cambios
            </button>
          </div>
        </form>
      {/if}
    </div>
  </div>        
</div>